import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { observer, inject } from 'mobx-react'

import inlineStyles from './inlineStyles'
import Column from '@client/components/Column/index'
import { BLOCK_TYPES } from '@client/components/Block/constants'
import {
  BlockModel,
  NULL as BlockModelNULL,
} from '@client/components/Block/model'
import EditorModel, {
  NULL as EditorModelNULL,
} from '@client/components/Editor/model'
import AppModel, { NULL as AppModelNULL } from '@client/components/App/model'
import {
  ITEM_TYPE_FORM,
  ITEM_TYPE_PAGE,
  ITEM_TYPE_LANDING_PAGE,
  ITEM_TYPE_LANDING_PAGE_SUCCESS,
  ITEM_TYPE_SURVEY,
  ITEM_TYPE_SURVEY_THANK_YOU,
  WIZARD_TYPE_PAGE,
  BUTTON_BORDER_STYLES,
} from '@client/components/Editor/settings'
import {
  FORMCOL_SECTION_BG_IMAGE_POSITION_TYPES,
  SECTION_LAYOUTS,
  TWOCOL_SECTION_BG_IMAGE_POSITION_TYPES,
  SECTION_TYPES,
  SECTION_WIDTH_TYPES_CLASS,
} from '@client/components/Section/constants'

const acceptTypes = Object.values(BLOCK_TYPES).filter(
  (item) => item !== BLOCK_TYPES.NULL && item !== BLOCK_TYPES.SECTION
)

const classNameByColumnCount = ['', 'one-column', 'two-column', 'three-column']

@inject('app', 'editor', 'serverRender')
@observer
class FlexContainerInner extends Component {
  static propTypes = {
    serverRender: PropTypes.bool,
    model: PropTypes.instanceOf(BlockModel),
    editor: PropTypes.instanceOf(EditorModel),
    app: PropTypes.instanceOf(AppModel),
  }

  static defaultProps = {
    serverRender: false,
    model: BlockModelNULL,
    editor: EditorModelNULL,
    app: AppModelNULL,
  }

  render() {
    const { app, model, editor, serverRender, count } = this.props
    const settings = model.settings.values

    const preparedAcceptTypes = (
      model.sectionType === SECTION_TYPES.PRODUCTSTHREECOL ||
      model.sectionType === SECTION_TYPES.PRODUCTSTWOCOL
    )
      ? [BLOCK_TYPES.PRODUCT] 
      : acceptTypes

    const tableStyles = {
      ...inlineStyles.innerTable,
      ...model.getInnerTableStyles(editor.settings),
    }

    const tableCellStyles = { padding: '0' }

    if (model.columns.length > 1) {
      tableCellStyles.textAlign = 'center'

      if (serverRender) {
        tableCellStyles.fontSize = '0'
      }
    }

    let borderStyles = {}

    if (
      model.settings.values.borderStyle &&
      model.settings.values.borderStyle !== BUTTON_BORDER_STYLES[0].value &&
      model.isContentWidth
    ) {
      borderStyles = { ...borderStyles, ...model.borderStyles, ...model.borderRadiusStyles }
    }

    const backgroundColor =
      model.settings.values.backgroundColor ||
      editor.settings.values.contentColor
    const backgroundImage =
      model.isContentWidth && settings.hasBackgroundImage
        ? settings.backgroundImageUrl || ''
        : ''

    if (model.isContentWidth && backgroundColor) {
      tableCellStyles.backgroundColor = backgroundColor
    }

    if (backgroundImage) {
      tableCellStyles.backgroundPosition = 'center'
      tableCellStyles.backgroundSize = 'cover'
      if (
        editor.kind !== ITEM_TYPE_FORM ||
        (editor.kind === ITEM_TYPE_FORM &&
          model.settings.values.bgImagePosition !==
            TWOCOL_SECTION_BG_IMAGE_POSITION_TYPES[0].value &&
          model.settings.values.bgImagePosition !==
            TWOCOL_SECTION_BG_IMAGE_POSITION_TYPES[2].value)
      ) {
        tableCellStyles.backgroundImage = `url('${backgroundImage}')`
      }
    }

    if (editor.kind === ITEM_TYPE_FORM) {
      tableCellStyles.display = 'flex'
      tableCellStyles.alignItems = 'stretch'
      tableCellStyles.justifyContent = 'center'
      if (
        model.settings.values.bgImagePosition ===
          FORMCOL_SECTION_BG_IMAGE_POSITION_TYPES[0].value ||
        model.settings.values.bgImagePosition ===
          FORMCOL_SECTION_BG_IMAGE_POSITION_TYPES[3].value
      ) {
        tableCellStyles.flexDirection = 'row'
      }
      if (
        model.settings.values.bgImagePosition ===
        FORMCOL_SECTION_BG_IMAGE_POSITION_TYPES[1].value
      ) {
        tableCellStyles.flexDirection = 'column'
      }
      if (
        model.settings.values.bgImagePosition ===
        FORMCOL_SECTION_BG_IMAGE_POSITION_TYPES[2].value
      ) {
        tableCellStyles.flexDirection = 'row-reverse'
      }
    }

    if (
      editor.kind === ITEM_TYPE_PAGE ||
      editor.kind === ITEM_TYPE_LANDING_PAGE ||
      editor.kind === ITEM_TYPE_LANDING_PAGE_SUCCESS ||
      editor.kind === ITEM_TYPE_SURVEY ||
      editor.kind === ITEM_TYPE_SURVEY_THANK_YOU
    ) {
      tableCellStyles.display = 'flex'
      tableCellStyles.justifyContent = 'center'
      tableCellStyles.flexDirection = 'row'
      tableCellStyles.maxWidth = '800px'
      tableCellStyles.margin = '0 auto'
      tableCellStyles.alignItems = model.settings.values.alignItems
      if (editor.kind === ITEM_TYPE_SURVEY) {
        tableCellStyles.maxWidth = '640px'
      }
    }

    if (
      app.wizard.type === WIZARD_TYPE_PAGE && (
        editor.kind === ITEM_TYPE_PAGE ||
        editor.kind === ITEM_TYPE_LANDING_PAGE ||
        editor.kind === ITEM_TYPE_LANDING_PAGE_SUCCESS
      ) && (
        model.sectionType === SECTION_TYPES.LANDINGONECOL ||
        model.sectionType === SECTION_TYPES.LANDINGTWOCOL
      )
    ) {
      const maxWidthClass = SECTION_WIDTH_TYPES_CLASS[model.settings.values.widthType]
      if (model.columns.length === 1) {
        return (
          <div
            className={`one-col ${maxWidthClass} section-inner`}
            style={model.getInnerTableStyles(editor.settings)}
          >
            <For each="column" index="index" of={model.columns}>
              <Column
                column={column}
                index={index}
                key={column.id}
                acceptTypes={preparedAcceptTypes}
                model={model}
                count={model.columns.length}
              />
            </For>
          </div>

        )
      } else if (
        model.columns.length > 1 ||
        model.settings.values.layout === SECTION_LAYOUTS[2].value
      ) {
        return (
          <div
            className={`two-col ${maxWidthClass} section-inner ${
              model.settings.values.stackColumnsOnMobile ? 'stack' : ''
            }`}
            style={{
              ...model.getInnerTableStyles(editor.settings),
              gap: typeof model.settings.values.middlePadding !== 'undefined'
                ? `${model.settings.values.middlePadding}px`
                : undefined
            }}
          >
            <For each="column" index="index" of={model.columns}>
              <Column
                column={column}
                index={index}
                key={column.id}
                acceptTypes={preparedAcceptTypes}
                model={model}
                count={model.columns.length}
              />
            </For>
          </div>
        )
      }
    }

    return (
      <div
        className={serverRender ? '' : 'section-inner'}
        style={tableStyles}
        align="center"
        ref={(el) => (this.dom = el)}
      >
        <div
          className={`${
            classNameByColumnCount[
              editor.kind === ITEM_TYPE_FORM ? 2 : model.columns.length
            ]
          } ${model.hasGutter ? 'with-gutter' : ''}`}
          valign="top"
          style={{ ...tableCellStyles, ...borderStyles }}
          align="center"
        >
          <For each="column" index="index" of={model.columns}>
            <If condition={index > 0 && model.hasGutter}>
              <div
                className="gutter"
                style={{
                  display: 'inline-block',
                  height: '20px',
                  width: '20px',
                }}
                dangerouslySetInnerHTML={{
                  __html: '&nbsp;',
                }}
              />
            </If>
            <Column
              column={column}
              index={index}
              key={column.id}
              acceptTypes={preparedAcceptTypes}
              model={model}
            />
          </For>
        </div>
      </div>
    )
  }
}

export default FlexContainerInner
